<template>
    <div class="flex items-center">
        <template v-if="!label">
            <svg-icon v-if="showWarningIcon" type="warning" class="max-w-12 max-h-12 text-semantic-warning mr-8"></svg-icon>
            <span :class="missingTranslationStyle">
                {{ $t('general.missing_translation') }} ({{ overrideLocale || locale }})
            </span>
        </template>
        <slot/>
        {{ label }}
    </div>
</template>

<script>
import SvgIcon from "./ui/SvgIcon.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        label: String,
        missingTranslationStyle: {
            type: String,
            default: 'italic font-normal'
        },
        showWarningIcon: {
            type: Boolean,
            default: true
        },
        overrideLocale: String
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        }
    }
}
</script>

<style scoped>

</style>
